import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
// later for better performance
// it's better to import only the needed
// component modules for element-ui
// http://element.eleme.io/#on-demand
import {
  Dialog,
  Autocomplete,
  Carousel,
  CarouselItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  Checkbox,
  Select,
  Steps,
  Step,
  Option,
  Popover,
  Button,
  Tooltip,
  Tag,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Rate,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Row,
  Col,
  Loading,
  MessageBox,
  Message,
  Notification,
  Card,
  Collapse,
  CollapseItem,
} from 'element-ui';
import VueQriously from 'vue-qriously';
import Agent from '@egjs/agent';
import App from './App';
import router from './router';
import store from './store';
import './assets/css/element-variables.scss';

Vue.config.productionTip = false;

locale.use(lang);

Vue.use(VueQriously);
// element ui
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(MenuItemGroup);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Option);
Vue.use(Popover);
Vue.use(Button);
Vue.use(Tooltip);
Vue.use(Tag);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Row);
Vue.use(Col);
Vue.use(Rate);
Vue.use(Card);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Loading.directive);
// vueclipbaord
Vue.use(VueClipboard);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

const userAgent = Agent();
Vue.prototype.$MOBILE = userAgent.isMobile;
Vue.prototype.$BROWSER = userAgent.browser.name;
Vue.prototype.$BROWSER_VERSION = userAgent.browser.version;
Vue.prototype.$OS = userAgent.os.name;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js